import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=4f53e17a&scoped=true"
import script from "./confirmOrder.vue?vue&type=script&lang=js"
export * from "./confirmOrder.vue?vue&type=script&lang=js"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=4f53e17a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53e17a",
  null
  
)

export default component.exports